import { StyledFormGroup } from "../styled-form-group";
import { Switch } from "@blueprintjs/core";
import React, {
  ChangeEvent,
  ChangeEventHandler,
  FunctionComponent
} from "react";
import "styled-components/macro";

type ResubscribeInputProps = {
  disabled: boolean;
  value: boolean;
  onValueChange: any;
  activeField: string;
  setActiveField: any;
};

export function MySwitch({
  disabled,
  value,
  onValueChange,
  setActiveField,
  ...props
}) {
  const onChange: ChangeEventHandler<HTMLInputElement> = (
    ev: ChangeEvent<HTMLInputElement>
  ) => {
    onValueChange(ev.target.checked);
  };
  return (
    <Switch
      disabled={disabled}
      name="resubscribe"
      checked={value}
      onChange={onChange}
      onFocus={() => setActiveField("resubscribe")}
      large
      {...props}
    />
  );
}

export const ResubscribeInput: FunctionComponent<ResubscribeInputProps> = ({
  disabled,
  value,
  onValueChange,
  activeField,
  setActiveField
}) => {
  return (
    <StyledFormGroup
      label="Resubscribe"
      labelFor="resubscribe"
      helperText="Keep showing me other cheaper fares for this trip leg"
      activeField={activeField}
      alwaysShowHelperText
    >
      <MySwitch
        data-testid="report_action_form__resubscribe_input"
        disabled={disabled}
        value={value}
        onValueChange={onValueChange}
        setActiveField={setActiveField}
      />
    </StyledFormGroup>
  );
};
